import { render, staticRenderFns } from "./AncillaryReissueSearchLegHeader.vue?vue&type=template&id=05ba7bfc&scoped=true"
import script from "./AncillaryReissueSearchLegHeader.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegHeader.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegHeader.vue?vue&type=style&index=0&id=05ba7bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba7bfc",
  null
  
)

export default component.exports